<template lang="pug">
.ignore
  img.ercode(:class="size" :src="imageTypeEnum[imageType]" alt="loklok placeholder" width="200" height="200")
  h1 {{title || $t('globalTip.emptyTip')}}
  p {{text}}
</template>

<script>
export default {
  name: 'fq-ignore',
  data() {
    return {
      imageTypeEnum: {
        contentEmpty: 'https://static.loklok.video/img/nocontent220120.png?imageMogr2/format/webp',
        error: 'https://static.loklok.video/img/错误.png?imageMogr2/format/webp',
        noNetwork: 'https://static.loklok.video/img/nonetwork.png?imageMogr2/format/webp'
      }
    }
  },
  props: {
    imageType: {
      type: String,
      default: 'contentEmpty'
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      // default: '请扫码下载LoklokAPP，观看更多影视内容'
      default: ''
    },
    size: {
      type: String,
      // 站位图的宽度和高度  mini middle large  目前用到的全屏是large 240px middle 200px  mini 160px
      default: 'middle'
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../styles/index'

.ignore
  @include flex($flexDirection: column)
  padding: 80px 0 0
  width: 100%
  h1
    font-weight: 900
    font-size: 18px
    line-height: 120%
    color: $mainTextColor
  p
    font-weight: bold
    font-size: 14px
    line-height: 120%
    text-align: center
    color: #999999
    margin-top: 20px
    margin-bottom: 12.5px
  img
    width: 160px
    height: 160px
  .large
    width: 240px
    height: 240px
  .middle
    width: 200px
    height: 200px
  .mini
    width: 160px
    height: 160px
</style>
